const seatRouters = [{
  path: '/custom/seat/area',
  name: 'customSeatArea',
  component: resolve => require(['@/views/seat/seatArea/index'], resolve),
}];
export default seatRouters;
